<template>
  <div id="app">
    <router-view/>

    <div class="arrecredi_qrcode">
      <div class="arrecredi_qrcode_title">Descargar App</div>
      <div class="arrecredi_qrcode_dv">
        <img src="./assets/img/arrecredi_qrcode_1.jpeg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {

    }
  },
  mounted(){
    window.addEventListener('hashchange',()=>{
      var currentPath = window.location.hash.slice(1); // 获取输入的路由
      if(this.$router.path !== currentPath){
        this.$router.push(currentPath); // 动态跳转
      }
    },false);
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  p, ul {
    margin: 0;
  }
  a {
    text-decoration: none;
    cursor: pointer;
  }
  .mainContent {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .arrecredi_qrcode{
    width: 198px;
    height: 160px;
    background: #0099BC;
    border-radius: 20px;
    position: fixed;
    right: 100px;
    bottom: 58px;
    z-index: 999;
    box-sizing: border-box;
    padding: 10px 0 0 0;
  }
  .arrecredi_qrcode_title{
    width: 100%;
    height: 30px;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }
  .arrecredi_qrcode_dv{
    width: 84px;
    height: 84px;
    margin: 12px auto 0 auto;
    border: 1px solid #979797;
  }
  .arrecredi_qrcode_dv img{
    display: block;
    width: 84px;
    height: 84px;
  }

  /* 小屏适配：内容区域全宽 + 隐藏右下角二维码，避免遮挡内容 */
  @media (max-width: 768px) {
    .mainContent {
      width: 100%;
      box-sizing: border-box;
      padding: 0 16px;
    }
    .arrecredi_qrcode{
      display: none;
    }
  }
</style>
